export interface StringifyUserIdArgs {
  userId?: number;
}

export function stringifyUserId({ userId }: StringifyUserIdArgs) {
  return userId === undefined ? undefined : String(userId);
}
